import { type UseFieldConfig, useField } from "react-final-form";
import type { JSX } from "react";

interface IOwnProps {
    label?: string;
    placeholder?: string;
    name: string;
    className?: string;
    maxLength?: number;
}

type IProps<T> = IOwnProps & UseFieldConfig<T>;

function Input<T = string>({ name, label, placeholder, className, maxLength, ...props }: IProps<T>): JSX.Element {
    const {
        input,
        meta: { touched, error },
    } = useField<any, HTMLInputElement>(name, props);
    return (
        <div className={touched && error ? `error ${className}` : className || ""}>
            <label>
                {label && `${label}: `}
                <input {...input} placeholder={placeholder} maxLength={maxLength} />
                {touched && error && <small className="error">{error}</small>}
            </label>
        </div>
    );
}

export default Input;
